export default __webpack_public_path__ + "static/Bild Seite 2 - Verkäuferin-6a08df57dcaaf14d132ff636026bf94b.jpg";